(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6553],{

/***/ 665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var react_accessible_accordion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75101);
/* harmony import */ var _components_global_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55689);
/* harmony import */ var _lib_hooks_mediaQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99182);
/* harmony import */ var _Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58066);
/* harmony import */ var _Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var Arrow = function(param) {
    var expanded = param.expanded, color = param.color, iconSize = param.iconSize;
    var screen = (0,_lib_hooks_mediaQuery__WEBPACK_IMPORTED_MODULE_3__/* .useScreenSize */ .e)();
    var _iconSize = iconSize ? iconSize : screen === "Mobile" ? "16" : "24";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().arrow),
        children: expanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            color: color,
            iconName: "arrow-up",
            width: _iconSize,
            height: _iconSize
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            color: color,
            iconName: "arrow-down",
            width: _iconSize,
            height: _iconSize
        })
    });
};
var AccordionItem = function(param) {
    var _titleHeading = param.titleHeading, titleHeading = _titleHeading === void 0 ? "h5" : _titleHeading, children = param.children, title = param.title, uid = param.uid, iconColor = param.iconColor, iconSize = param.iconSize;
    var Heading = titleHeading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_accessible_accordion__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItem */ .Qd, {
        uuid: uid,
        className: (_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().accordionItem),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_accessible_accordion__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItemHeading */ .Ol, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_accessible_accordion__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItemButton */ .on, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().heading),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_accessible_accordion__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItemState */ .CB, {
                                children: function(state) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Arrow, {
                                        color: iconColor,
                                        expanded: state.expanded,
                                        iconSize: iconSize
                                    });
                                }
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_accessible_accordion__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItemPanel */ .Mt, {
                className: (_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().accordionItemPanel),
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionItem);


/***/ }),

/***/ 58343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InViewContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);
/* harmony import */ var react_accessible_accordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75101);
/* harmony import */ var _Accordion_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58066);
/* harmony import */ var _Accordion_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var InViewContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    inView: false
});
var Accordion = function(param) {
    var children = param.children, _allowMultipleExpanded = param.allowMultipleExpanded, allowMultipleExpanded = _allowMultipleExpanded === void 0 ? false : _allowMultipleExpanded, _allowZeroExpanded = param.allowZeroExpanded, allowZeroExpanded = _allowZeroExpanded === void 0 ? false : _allowZeroExpanded;
    var firstAccordionItem = children && children[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_accessible_accordion__WEBPACK_IMPORTED_MODULE_2__/* .Accordion */ .UQ, {
        className: (_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_3___default().accordionWrapper),
        preExpanded: [
            firstAccordionItem === null || firstAccordionItem === void 0 ? void 0 : firstAccordionItem.key
        ],
        allowMultipleExpanded: allowMultipleExpanded,
        allowZeroExpanded: allowZeroExpanded,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Accordion);


/***/ }),

/***/ 76846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ FaqSearchContext; },
/* harmony export */   "x": function() { return /* binding */ FaqSearchProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);


var FaqSearchContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var FaqSearchProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), searchValue = ref[0], setSearchValue = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedCategory = ref1[0], setSelectedCategory = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), selectedTag = ref2[0], setSelectedTag = ref2[1];
    var _setSearchValue = function(value) {
        setSearchValue(value);
        setSelectedTag("");
        setSelectedCategory(null);
    };
    var _setSelectedTag = function(tag) {
        setSearchValue("");
        setSelectedTag(tag);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqSearchContext.Provider, {
        value: {
            searchValue: searchValue,
            setSearchValue: _setSearchValue,
            selectedCategory: selectedCategory,
            setSelectedCategory: setSelectedCategory,
            selectedTag: selectedTag,
            setSelectedTag: _setSelectedTag
        },
        children: children
    });
};


/***/ }),

/***/ 28316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cms_RichText; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/link.js
var next_link = __webpack_require__(40559);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
;// CONCATENATED MODULE: ./node_modules/.pnpm/storyblok-rich-text-react-renderer@2.6.0_react@18.0.0/node_modules/storyblok-rich-text-react-renderer/dist/index.es.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

const _excluded = ["component"];
const NODE_HEADING = 'heading';
const NODE_CODEBLOCK = 'code_block';
const NODE_PARAGRAPH = 'paragraph';
const NODE_QUOTE = 'blockquote';
const NODE_OL = 'ordered_list';
const NODE_UL = 'bullet_list';
const NODE_LI = 'list_item';
const NODE_HR = 'horizontal_rule';
const NODE_BR = 'hard_break';
const NODE_IMAGE = 'image';
const MARK_BOLD = 'bold';
const MARK_ITALIC = 'italic';
const MARK_STRIKE = 'strike';
const MARK_UNDERLINE = 'underline';
const MARK_CODE = 'code';
const MARK_LINK = 'link';
const MARK_STYLED = 'styled';
function render(document, options = {}) {
  if (typeof document === 'object' && document.type === 'doc' && Array.isArray(document.content)) {
    const _options$blokResolver = options.blokResolvers,
          blokResolvers = _options$blokResolver === void 0 ? {} : _options$blokResolver,
          _options$defaultBlokR = options.defaultBlokResolver,
          defaultBlokResolver = _options$defaultBlokR === void 0 ? function () {
      return null;
    } : _options$defaultBlokR,
          _options$nodeResolver = options.nodeResolvers,
          customNodeResolvers = _options$nodeResolver === void 0 ? {} : _options$nodeResolver,
          _options$markResolver = options.markResolvers,
          customMarkResolvers = _options$markResolver === void 0 ? {} : _options$markResolver,
          _options$textResolver = options.textResolver,
          textResolver = _options$textResolver === void 0 ? function (str) {
      return str;
    } : _options$textResolver;

    const nodeResolvers = _objectSpread2(_objectSpread2({}, defaultNodeResolvers), customNodeResolvers);

    const markResolvers = _objectSpread2(_objectSpread2({}, defaultMarkResolvers), customMarkResolvers);

    let currentKey = 0;

    const addKey = function (element) {
      return react.isValidElement(element) ? react.cloneElement(element, {
        key: currentKey++
      }) : element;
    };

    const renderNodes = function (nodes) {
      const elements = nodes ? nodes.map(renderNode).filter(function (node) {
        return node != null;
      }) : null;
      return Array.isArray(elements) && elements.length === 0 ? null : elements;
    };

    const renderNode = function (node) {
      if (node.type === 'blok') {
        const body = node.attrs.body;
        return body.map(function (_ref) {
          let component = _ref.component,
              props = _objectWithoutProperties(_ref, _excluded);

          const resolver = blokResolvers[component];
          const element = resolver ? resolver(props) : defaultBlokResolver(component, props);
          return addKey(element);
        });
      } else {
        var _node$marks;

        let childNode;

        if (node.type === 'text') {
          childNode = textResolver(node.text);
        } else {
          const resolver = nodeResolvers[node.type];
          childNode = resolver ? addKey(resolver(renderNodes(node.content), node.attrs)) : null;
        }

        const marks = (_node$marks = node.marks) !== null && _node$marks !== void 0 ? _node$marks : [];
        return marks.reduceRight(function (children, mark) {
          const resolver = markResolvers[mark.type];
          return resolver ? addKey(resolver(children, mark.attrs)) : children;
        }, childNode);
      }
    };

    return renderNodes(document.content);
  } else if (typeof document === 'string') {
    const _options$defaultStrin = options.defaultStringResolver,
          defaultStringResolver = _options$defaultStrin === void 0 ? function (str) {
      return str;
    } : _options$defaultStrin,
          _options$textResolver2 = options.textResolver,
          textResolver = _options$textResolver2 === void 0 ? function (str) {
      return str;
    } : _options$textResolver2;
    return defaultStringResolver(textResolver(document));
  }

  return null;
}

const simpleNodeResolver = function (element) {
  return function (children) {
    return children != null ? react.createElement(element, null, children) : null;
  };
};

const emptyNodeResolver = function (element) {
  return function () {
    return react.createElement(element);
  };
};

const headingNodeResolver = function (children, props) {
  return react.createElement(`h${props.level}`, null, children);
};

const imageNodeResolver = function (children, props) {
  return react.createElement('img', props, children);
};

const codeblockNodeResolver = function (children, props) {
  const codeProps = {
    className: props.class
  };
  const code = react.createElement('code', codeProps, children);
  return react.createElement('pre', null, code);
};

const simpleMarkResolver = function (element) {
  return function (children) {
    return react.createElement(element, null, children);
  };
};

const linkMarkResolver = function (children, {
  linktype,
  href,
  target
}) {
  const props = {
    href: linktype === 'email' ? `mailto:${href}` : href,
    target
  };
  return react.createElement('a', props, children);
};

const styledMarkResolver = function (children, props) {
  return react.createElement('span', {
    className: props.class
  }, children);
};

const defaultNodeResolvers = {
  [NODE_HEADING]: headingNodeResolver,
  [NODE_CODEBLOCK]: codeblockNodeResolver,
  [NODE_IMAGE]: imageNodeResolver,
  [NODE_PARAGRAPH]: simpleNodeResolver('p'),
  [NODE_QUOTE]: simpleNodeResolver('blockquote'),
  [NODE_OL]: simpleNodeResolver('ol'),
  [NODE_UL]: simpleNodeResolver('ul'),
  [NODE_LI]: simpleNodeResolver('li'),
  [NODE_HR]: emptyNodeResolver('hr'),
  [NODE_BR]: emptyNodeResolver('br')
};
const defaultMarkResolvers = {
  [MARK_LINK]: linkMarkResolver,
  [MARK_STYLED]: styledMarkResolver,
  [MARK_BOLD]: simpleMarkResolver('b'),
  [MARK_ITALIC]: simpleMarkResolver('i'),
  [MARK_STRIKE]: simpleMarkResolver('s'),
  [MARK_UNDERLINE]: simpleMarkResolver('u'),
  [MARK_CODE]: simpleMarkResolver('code')
};


//# sourceMappingURL=index.es.js.map

// EXTERNAL MODULE: ./components/cms/RichText/Text.module.scss
var Text_module = __webpack_require__(35762);
var Text_module_default = /*#__PURE__*/__webpack_require__.n(Text_module);
;// CONCATENATED MODULE: ./components/cms/RichText/index.tsx
function RichText_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RichText_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

/* eslint-disable react/display-name */ 




var adaptivePresets = function(size) {
    var mobile = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var sizes = {
        h1: (Text_module_default())["".concat(mobile ? "mobile-" : "", "u-h1")],
        h2: (Text_module_default())["".concat(mobile ? "mobile-" : "", "u-h2")],
        h3: (Text_module_default())["".concat(mobile ? "mobile-" : "", "u-h3")],
        h4: (Text_module_default())["".concat(mobile ? "mobile-" : "", "u-h4")],
        h5: (Text_module_default())["".concat(mobile ? "mobile-" : "", "u-h5")],
        h6: (Text_module_default())["".concat(mobile ? "mobile-" : "", "u-h6")],
        example: (Text_module_default())["other-styles-later"]
    };
    return sizes[size];
};
var RichText = function(param) {
    var content = param.content, _align = param.align, align = _align === void 0 ? "left" : _align, maxWidth = param.maxWidth, isSectionCentered = param.isSectionCentered, largeParagraphText = param.largeParagraphText, _textXS = param.textXS, textXS = _textXS === void 0 ? false : _textXS, justify = param.justify, fontFamily = param.fontFamily, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? "" : _fontSize, mobileFontSize = param.mobileFontSize, color = param.color, colorPreset = param.colorPreset, textSize = param.textSize, lineHeight = param.lineHeight, displayListInline = param.displayListInline, mobileTextSize = param.mobileTextSize;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: _objectSpread({
            maxWidth: maxWidth ? "".concat(maxWidth, "px") : "unset"
        }, fontSize && {
            fontSize: fontSize
        }, fontFamily && {
            "--font": fontFamily || "inherit"
        }, {
            color: color || colorPreset || "var(--color-primary)"
        }, lineHeight && {
            "--line-height": lineHeight
        }),
        className: (0,clsx_m/* default */.Z)((_obj = {}, RichText_defineProperty(_obj, (Text_module_default()).text, true), RichText_defineProperty(_obj, (Text_module_default())["align-".concat(align)], align), RichText_defineProperty(_obj, (Text_module_default()).sectionCentered, isSectionCentered), RichText_defineProperty(_obj, "large-text", largeParagraphText), RichText_defineProperty(_obj, (Text_module_default())["text-xs"], textXS), RichText_defineProperty(_obj, (Text_module_default())["justify-".concat(justify)], justify), RichText_defineProperty(_obj, (Text_module_default()).hasColorParameter, color || colorPreset), RichText_defineProperty(_obj, (Text_module_default()).hasFontSizeParameter, fontSize), RichText_defineProperty(_obj, (Text_module_default()).displayListInline, displayListInline), RichText_defineProperty(_obj, (Text_module_default()).mobileFontSize, mobileFontSize), _obj), textSize && adaptivePresets(textSize), mobileTextSize && adaptivePresets(mobileTextSize, true), (Text_module_default()).boldStyles, (Text_module_default()).italicStyles, (Text_module_default()).codeInlineStyles),
        children: render(content, {
            markResolvers: RichText_defineProperty({}, MARK_LINK, function(children, props) {
                var href = props.href, target = props.target, linktype = props.linktype;
                if (linktype === "email") {
                    // Email links: add `mailto:` scheme and map to <a>
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:".concat(href),
                        children: children
                    });
                }
                if (href && href.match(/^(https?:)?\/\//)) {
                    // External links: map to <a>
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: href,
                        target: target,
                        children: children
                    });
                }
                // Internal links: map to <Link>
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: href,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: target,
                        children: children
                    })
                });
            })
        })
    });
};
/* harmony default export */ var cms_RichText = (RichText);


/***/ }),

/***/ 6553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_FaqItemsWrapper; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/Button/index.tsx + 2 modules
var Button = __webpack_require__(80772);
// EXTERNAL MODULE: ./components/cms/Accordion/index.tsx
var Accordion = __webpack_require__(58343);
// EXTERNAL MODULE: ./components/cms/Accordion/AccordionItem.tsx
var AccordionItem = __webpack_require__(665);
// EXTERNAL MODULE: ./components/cms/FaqSearch/FaqSearchContext.tsx
var FaqSearchContext = __webpack_require__(76846);
// EXTERNAL MODULE: ./components/cms/RichText/index.tsx + 1 modules
var RichText = __webpack_require__(28316);
// EXTERNAL MODULE: ./components/cms/FaqItems/FaqItems.module.scss
var FaqItems_module = __webpack_require__(77925);
var FaqItems_module_default = /*#__PURE__*/__webpack_require__.n(FaqItems_module);
;// CONCATENATED MODULE: ./components/cms/FaqItems/helpers.ts
var getFilteredItems = function(items, searchValue, selectedTag) {
    if (selectedTag) {
        var itemsList = items.filter(function(item) {
            if (!item.topics) return false;
            var _topics = item === null || item === void 0 ? void 0 : item.topics.join("/").toLocaleLowerCase().replace(" ", "_").split("/");
            return _topics.includes(selectedTag);
        });
        return itemsList;
    }
    if (searchValue) {
        var itemsList1 = items.filter(function(faqItem) {
            if (!searchValue && !selectedTag) return false;
            var question = faqItem.question.toLowerCase();
            var answer = faqItem.answer;
            var contentArray = answer === null || answer === void 0 ? void 0 : answer.content.map(function(currentValue) {
                var contentText = currentValue === null || currentValue === void 0 ? void 0 : currentValue.content.map(function(contentItem) {
                    return (contentItem === null || contentItem === void 0 ? void 0 : contentItem.text) ? contentItem === null || contentItem === void 0 ? void 0 : contentItem.text.toLocaleLowerCase() : "";
                });
                return contentText;
            });
            var contentString = contentArray.join(" ");
            if (question.includes(searchValue.toLocaleLowerCase()) || contentString.includes(searchValue.toLocaleLowerCase())) {
                return true;
            }
        });
        return itemsList1;
    }
    return [];
};

;// CONCATENATED MODULE: ./components/cms/FaqItems/FaqItems.tsx









var FaqItems = function(param) {
    var items = param.items, title = param.title, notFoundTitle = param.notFoundTitle;
    var ref = (0,react.useContext)(FaqSearchContext/* FaqSearchContext */.l), searchValue = ref.searchValue, selectedTag = ref.selectedTag, selectedCategory = ref.selectedCategory;
    var filteredItems = getFilteredItems(items, searchValue, selectedTag);
    var actualTitle = filteredItems.length > 0 ? title : notFoundTitle;
    var renderItems = filteredItems.length > 0 ? filteredItems : items === null || items === void 0 ? void 0 : items.slice(0, 10);
    var getTitle = function() {
        return searchValue || selectedTag ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
            content: selectedCategory ? selectedCategory.name : actualTitle,
            align: "center",
            maxWidth: "1000",
            isSectionCentered: true,
            largeParagraphText: false
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
            children: "All FAQs"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (FaqItems_module_default()).FaqItemsContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FaqItems_module_default()).FaqItemsTitleWrapper,
                children: getTitle()
            }),
            selectedCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FaqItems_module_default()).FaqItemsCategoryWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                    content: selectedCategory.description,
                    align: "center",
                    maxWidth: "1000",
                    isSectionCentered: true,
                    largeParagraphText: false
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                allowMultipleExpanded: true,
                allowZeroExpanded: true,
                children: renderItems === null || renderItems === void 0 ? void 0 : renderItems.map(function(faq) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionItem/* default */.Z, {
                        title: faq.question,
                        uid: faq._uid,
                        iconColor: "var(--color-primary)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (FaqItems_module_default()).FaqItemsAccordionItemContent,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (FaqItems_module_default()).FaqItemsAccordionItemAnswerWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                                        content: faq.answer,
                                        align: "left",
                                        isSectionCentered: false,
                                        largeParagraphText: false
                                    })
                                }),
                                faq.buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "secondary",
                                    href: faq.buttonHref.linktype === "story" ? faq.buttonHref.cached_url : faq.buttonHref.url,
                                    children: faq.buttonText
                                })
                            ]
                        })
                    }, faq._uid);
                })
            })
        ]
    });
};
/* harmony default export */ var FaqItems_FaqItems = (FaqItems);

;// CONCATENATED MODULE: ./components/cms/FaqItems/index.tsx

/* harmony default export */ var cms_FaqItems = (FaqItems_FaqItems);

;// CONCATENATED MODULE: ./storyblok/components/FaqItemsWrapper.tsx


var FaqItemsWrapper = function(param) {
    var blok = param.blok;
    var items = blok.items, title = blok.title, notFoundTitle = blok.notFoundTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(cms_FaqItems, {
        title: title,
        items: items,
        notFoundTitle: notFoundTitle
    });
};
/* harmony default export */ var components_FaqItemsWrapper = (FaqItemsWrapper);


/***/ }),

/***/ 58066:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordionItemPanel":"Accordion_accordionItemPanel__zruEv","accordionItem":"Accordion_accordionItem__2nq7c","heading":"Accordion_heading__ptMcF","title":"Accordion_title__pTA9V","arrow":"Accordion_arrow__wUcgU"};

/***/ }),

/***/ 77925:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"FaqItemsContainer":"FaqItems_FaqItemsContainer__WvAOZ","FaqItemsTitleWrapper":"FaqItems_FaqItemsTitleWrapper__fQD2E","FaqItemsAccordionItemContent":"FaqItems_FaqItemsAccordionItemContent__Ii_ZJ","FaqItemsAccordionItemAnswerWrapper":"FaqItems_FaqItemsAccordionItemAnswerWrapper__F_YWz","FaqItemsCategoryWrapper":"FaqItems_FaqItemsCategoryWrapper__pr4tC"};

/***/ }),

/***/ 35762:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__dlJSN","align-left":"Text_align-left__MFqYL","align-center":"Text_align-center__kKp_u","align-right":"Text_align-right__P2I2z","sectionCentered":"Text_sectionCentered__DcjpN","text-xs":"Text_text-xs__JXqsq","justify-bottom":"Text_justify-bottom__6ozWY","font-family-mono":"Text_font-family-mono__o14zZ","font-family-custom-font":"Text_font-family-custom-font__1VBUc","hasColorParameter":"Text_hasColorParameter__zqqMA","hasFontSizeParameter":"Text_hasFontSizeParameter__1XJ_8","mobile-u-h5":"Text_mobile-u-h5__NaRQc u-h5 u-h5","displayListInline":"Text_displayListInline__nCQK4","u-h2":"Text_u-h2__Z5vUl u-h2 u-h2","u-h3":"Text_u-h3__4eOKB u-h3","u-h4":"Text_u-h4__nq2Qc u-h4","u-h5":"Text_u-h5__k_2Vo u-h5","u-h6":"Text_u-h6__czPWa u-h6","boldStyles":"Text_boldStyles__ijfQG","codeInlineStyles":"Text_codeInlineStyles__PRcaG","mobileFontSize":"Text_mobileFontSize__tTrQj","mobile-u-h1":"Text_mobile-u-h1__jN6U_ u-h1","mobile-u-h2":"Text_mobile-u-h2__HonyE u-h2","mobile-u-h3":"Text_mobile-u-h3__YsfIB u-h3","mobile-u-h4":"Text_mobile-u-h4__SK5PH u-h4"};

/***/ })

}]);